import { BrandEndpoints } from '@/modules/preference/brand/api/brandEndpoints'

/**
 * Brand endpoint instance
 * instantiates brand api class with a different api path
 */
export const brandEndpoints = new BrandEndpoints()
